import axios from '../../../axios';
import CareerBuilderEdgeSearch from '../types/CareerBuilderEdgeSearch';

export const searchCareerBuilderEdge = async (query: CareerBuilderEdgeSearch) =>
  await axios.post('/candidatesearch/api/career-builder/edge/search', query);

export const fetchCandidateDetailsForEdge = (accountId: string, candidateId: string) =>
  axios.get(`/candidate-profile/${accountId}/${candidateId}/careerbuilderedge`);
